<!--
 * @message:全局弹窗
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-06 10:16:54
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_normalDialog.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-14 13:13:42
-->
<template>
  <div>
    <v-dialog
      v-model="dialog"
      :key="curKey"
      :width="deleteModel ? 300 : width"
      :hide-overlay="hideOverlay"
      style="min-width: 680px !important"
      :max-width="maxWidth"
      :no-click-animation="noClickAnimation"
      :overlay-opacity="overlayOpacity"
      :overlay-color="overlayColor"
      :persistent="persistent"
      @click:outside="persistent ? null : closeDialog()"
      :scrollable="scrollable"
    >
      <template v-slot:activator="{ on, attrs }" v-if="isTriger">
        <slot name="activator" :on="on" :attrs="attrs">
          <v-btn v-on="on"></v-btn>
        </slot>
      </template>
      <v-card :elevation="3" class="rounded-lg">
        <v-toolbar
          :color="`${color} `"
          v-if="show_title"
          class="white--text"
          flat
          dense
          height="40"
        >
          <v-toolbar-title
            v-if="deleteModel"
            class="text-body-2"
            :class="headerClass"
            >警告</v-toolbar-title
          >
          <v-toolbar-title v-else class="text-body-2" :class="headerClass">
            {{ title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.stop="closeDialog"
            :color="closeBtnColor"
            :ripple="false"
            height="35"
            x-small
            width="35"
          >
            <span class="material-icons-round md-24">close</span>
          </v-btn>
        </v-toolbar>
        <!-- 副标题 -->
        <slot name="subtitle"></slot>
        <v-card-text :class="'pa-' + pad">
          <slot name="content">
            <v-sheet v-if="deleteModel">是否删除{{ title }}?</v-sheet>
          </slot>
        </v-card-text>
        <slot name="actions">
          <CardActions
            okBtn
            @cancel="onTriger('close')"
            @ok="onTriger('confirm')"
            v-if="deleteModel"
          />
        </slot>
        <slot name="tools"></slot>
        <!-- <v-card-actions v-if="!noAction">
          <slot name="cancel">
            <v-btn text color="grey lighten-2" @click.stop="closeDialog">取消</v-btn>
          </slot>
          <slot name="confirm" />
        </v-card-actions>-->
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "normalDialog",
  props: {
    width: { default: 680, type: [Number, String] },
    pad: { default: 8, type: [Number, String] },
    title: { default: "", type: String },
    show_title: { default: true, type: Boolean },
    color: { default: "black", type: String },
    isTriger: { default: false, type: Boolean },
    noAction: { default: false, type: Boolean },
    deleteModel: { default: false, type: Boolean }, //快捷model
    dialog: { default: false, type: Boolean },
    hideOverlay: { default: false, type: Boolean },
    noClickAnimation: { default: true, type: Boolean },
    persistent: { default: true, type: Boolean },
    maxWidth: { default: "80%", type: [Number, String] },
    overlayColor: { default: "black", type: String },
    overlayOpacity: { default: 0.5, type: [Number, String] },
    scrollable: { default: true, type: Boolean },
    transition: { default: "slide-y-transition", type: String },
    closeBtnColor: { default: "white", type: String },
    headerClass: { default: "", type: String },
    height: {
      default: 300,
      type: [String, Number],
    },
  },
  computed: {},
  data() {
    let curKey = Math.random() * 100000000;
    return {
      curKey: curKey,
    };
  },
  destroyed() {},
  watch: {
    dialog(val) {
      if (!val) {
        this.curKey = Math.random() * 100000000 + "refresh"; //用来刷新弹窗
      }
    },
    // dialog(val) {
    //   //监听退出按键
    //   const that = this;
    //   if (val)
    //    this.$Sleep(1000).then(() => {
    //       document.onkeydown = function (e) {
    //         var theEvent = e || window.event;
    //         var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
    //         if (code == 27) {
    //           that.closeDialog();
    //           return false;
    //         }
    //         return true;
    //       };
    //     });
    //   else document.onkeydown = undefined; //解绑
    // },
  },
  mounted() {},
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    onTriger: function (action) {
      this.$emit(action);
    },
  },
};
</script>
